import { render } from "./CloseButton.vue?vue&type=template&id=0e0ce27c&scoped=true&ts=true"
import script from "./CloseButton.vue?vue&type=script&lang=ts"
export * from "./CloseButton.vue?vue&type=script&lang=ts"

import "./CloseButton.vue?vue&type=style&index=0&id=0e0ce27c&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e0ce27c"]])

export default __exports__